import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';

/** A selected free-text keyword of the knowledge panel, removable with its X. */
@Component({
  selector: 'app-kp-keyword-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  host: { class: 'inline-block max-w-full align-middle' },
  template: `
    <span class="flex h-8 max-w-full items-center gap-2 whitespace-nowrap rounded-lg bg-gray-600 px-4 text-sm font-medium text-white">
      <span class="min-w-0 overflow-hidden text-ellipsis">{{ keyword() }}</span>
      <button type="button" class="flex shrink-0 cursor-pointer items-center" [attr.aria-label]="'Remove ' + keyword()" (click)="remove.emit()">
        <app-icon name="sapphire-close-small" [size]="16" />
      </button>
    </span>
  `,
})
export class KpKeywordChipComponent {
  public readonly keyword = input.required<string>();
  public readonly remove = output<void>();
}
